const initialState = {
    notes: []
};

const notesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_NOTES_SUCCESS':
            // SAFETY: Only spread if action.payload is actually an array.
            // If the API returns an object (e.g., {results: [...]}), 
            // you must change this to: action.payload.results
            return { 
                ...state, 
                notes: Array.isArray(action.payload) ? action.payload : [] 
            };
        
        case 'ADD_NOTE_SUCCESS':
            // SAFETY: Ensure state.notes is an array before spreading it.
            const currentNotes = Array.isArray(state.notes) ? state.notes : [];
            return { 
                ...state, 
                notes: [...currentNotes, action.payload] 
            };
            
        case 'DELETE_NOTE_SUCCESS':
            // SAFETY: Ensure state.notes is an array before calling filter.
            const notesArray = Array.isArray(state.notes) ? state.notes : [];
            return { 
                ...state, 
                notes: notesArray.filter(note => note.id !== action.payload) 
            };
            
        default:
            return state;
    }
};

export default notesReducer;